import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.pending_view.title',
        defaultMessage: `Thanks! We're reviewing your application`
    },
    description: {
        id: '_.pending_view.description',
        defaultMessage: `We'll aim to email you with a decision within 24 hours- we’re receiving more applications than usual at the moment, so please bear with us if we take a little longer.`
    }
});
